import { Box, Typography } from '@mui/material';
import { useAiChatStore } from '../store/aiChat.store';

/**
 * Format the conversation start date
 * Format: "Chat started on Mon 15 @ 2:30 PM" or "Chat started on Mon 15, 2024 @ 2:30 PM" if not current year
 */
function formatChatStartDate(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const isCurrentYear = date.getFullYear() === now.getFullYear();

  const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
  const dayNumber = date.getDate();
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).replace(' ', ' '); // Ensure consistent spacing

  if (isCurrentYear) {
    return `Chat started on ${dayName} ${dayNumber} @ ${time}`;
  } else {
    return `Chat started on ${dayName} ${dayNumber}, ${date.getFullYear()} @ ${time}`;
  }
}

export default function AiChatHeader() {
  const conversationTitle = useAiChatStore((state) => state.conversationTitle);
  const conversationCreatedAt = useAiChatStore((state) => state.conversationCreatedAt);

  // Don't render if no conversation metadata
  if (!conversationCreatedAt) {
    return null;
  }

  const subtitle = formatChatStartDate(conversationCreatedAt);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        mx: '24px',
        pt: '12px',
        pb: '12px',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 500, lineHeight: '20px', color: 'text.primary' }}>
        {conversationTitle || 'Untitled Conversation'}
      </Typography>
      <Typography sx={{ fontSize: '12px', fontWeight: 400, lineHeight: '16px', color: 'text.secondary' }}>
        {subtitle}
      </Typography>
    </Box>
  );
}
